import * as process from "process";

export const config = {
  environment: process.env.REACT_APP_DEPLOYMENT_ENV,
  host: process.env.REACT_APP_SHIELD_URL,
  port: process.env.REACT_APP_SHIELD_PORT,
  keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL,
  keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM,
  keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  graphqlEndpoint: process.env.REACT_APP_SHIELD_URL
    + `${process.env.REACT_APP_SHIELD_PORT ? `:${process.env.REACT_APP_SHIELD_PORT}` : ""}`
    + "/deathlok/graphql",
  grootEndpoint: process.env.REACT_APP_SHIELD_URL + "/groot",
  gtmId: process.env.REACT_APP_GTM_ID,
};

export type Config = typeof config;